import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import searchAgentView from 'views/agent/agent-transfers/search'; // Importing search agent view component
import transfersDetail from 'views/agent/agent-transfers/PagoPremio'; // Importing transfers detail component
import transfers1 from 'views/agent/agent-transfers/transfers1'; // Importing first transfers component
import transfers from 'views/agent/agent-transfers/transfers'; // Importing transfers component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the AgentsTransfersView.
 * @extends JetView
 */
export default class AgentsTransfersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disable responsive cell behavior
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply theme CSS
                    elements: [
                        {
                            width: 30, // Width of the button
                            css: 'back-button', // CSS class for back button
                            view: 'button', // Button component
                            type: 'icon', // Button type
                            icon: 'wxi-angle-left', // Icon for the button
                            id: 'back-button', // Unique ID for the button
                            align: 'center', // Align button to center
                            click: () => {
                                // Click event handler for back button
                                webix.html.removeCss(
                                    // Remove 'green' CSS class from button1
                                    $$('button1').$view,
                                    'green',
                                );
                                webix.html.removeCss(
                                    // Remove 'green' CSS class from button2
                                    $$('button2').$view,
                                    'green',
                                );
                                $$('formPagoPremio1').hide(); // Hide formPagoPremio1
                                $$('formPagoPremio').hide(); // Hide formPagoPremio
                                $$('formPago').hide(); // Hide formPago
                                $$('back-button').hide(); // Hide back button
                                $$('consult-section').show(); // Show consult section
                            },
                        },
                        {
                            view: 'label', // Label component
                            align: 'center', // Align label to center
                            label: _('Transferir a Usuario'), // Label text with localization
                        },
                        {
                            type: 'wide', // Wide type for the next element
                            css: 'close-bottom', // CSS class for close button
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                searchAgentView, // Include search agent view
                transfersDetail, // Include transfers detail view
            ],
        };
        const right = {
            type: 'wide', // Wide type for the right panel
            rows: [transfers1, transfers], // Include transfers components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique ID for the form
            type: 'wide', // Wide type for the form
            view: 'form', // Form component
            scroll: 'y', // Enable vertical scrolling
            css: 'my-background', // CSS class for background
            height: 0, // Initial height
            rows: [left, right], // Combine left and right panels
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        $$('back-button').hide(); // Hide the back button on initialization
    }
}

// FILE DOCUMENTED
